module.exports = __webpack_public_path__ + "static/media/footrise-60.7d6047ea.png";